module.exports = __webpack_public_path__ + "img/icons_facebook.ef9ac4b2.svg";